import React from 'react';
import PropTypes from 'prop-types';

import { Box, Typography, Modal, FormControl, TextField } from '@mui/material';

import { LoadingButton } from '@mui/lab';

import * as Yup from 'yup';
import { useFormik, Form, FormikProvider } from 'formik';

import { ActivateMerchantAndAssignDevice } from '../../../network/Merchants';
import { APP_CONSTANTS } from '../../../URLConstants';

// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 350,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  boxShadow: 24,
  py: 2,
  px: 4,
  borderRadius: 1
};

const DeviceSchema = Yup.object().shape({
  deviceId: Yup.string().required('Required')
});

MapDeviceWithMerchant.propTypes = {
  opneAssignedModal: PropTypes.bool,
  handleClose: PropTypes.func,
  onAction: PropTypes.func,
  merchantData: PropTypes.object
};

export default function MapDeviceWithMerchant({
  opneAssignedModal,
  handleClose,
  onAction,
  merchantData
}) {
  const addDeviceFormik = useFormik({
    initialValues: {
      deviceId: ''
    },
    validationSchema: DeviceSchema,
    onSubmit: () => {
      activateDevice(merchantData?.merchant?.vpa, addDeviceFormik.values?.deviceId);
    }
  });

  const { errors, touched, values, isSubmitting, handleSubmit, getFieldProps } = addDeviceFormik;

  function activateDevice(vpa, deviceImei) {
    ActivateMerchantAndAssignDevice(vpa, deviceImei)
      .then((_res) => {
        addDeviceFormik?.setSubmitting(false);
        onAction(
          APP_CONSTANTS?.MERCHANT_MAPPING_SUCCESSFULL,
          'Device has been mapped successfully'
        );
        handleClose();
      })
      .catch((err) => {
        addDeviceFormik?.setSubmitting(false);
        onAction(APP_CONSTANTS?.MERCHANT_MAPPING_UNSUCCESSFULL, err);
      });
  }

  return (
    <Box>
      <Modal
        open={opneAssignedModal}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <FormikProvider value={addDeviceFormik}>
          <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
            <Box sx={style}>
              <Typography sx={{ fontSize: 16, fontWeight: 700, fontFamily: 'Montserrat' }}>
                Map Device
              </Typography>
              <div>
                <FormControl fullWidth sx={{ mb: 1, mt: 2 }}>
                  <TextField
                    label="Enter Device IMEI"
                    id="deviceId"
                    name="deviceId"
                    variant="outlined"
                    {...getFieldProps('deviceId')}
                    error={Boolean(touched.deviceId && errors.deviceId)}
                    helperText={touched.deviceId && errors.deviceId}
                  />
                </FormControl>
              </div>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                <LoadingButton
                  loading={addDeviceFormik?.isSubmitting}
                  variant="contained"
                  type="submit"
                  size="medium"
                >
                  Map
                </LoadingButton>
              </Box>
            </Box>
          </Form>
        </FormikProvider>
      </Modal>
    </Box>
  );
}
